import api from '../../../global/api';
import { Fusion } from '../../../components/admin/fusion-process/fusion-process-types';

export async function getFusionApi(_: string, fusionId: string) {
  const response = await api.get<Fusion>(`/fusion/${fusionId}`);
  return response.data;
}
